interface MenuIconProps {
  color?: string;
  size?: number;
}

function MenuIcon({ color = "#ffffff", size = 60 }: MenuIconProps) {
  return (
    <svg
      width={size}
      // height="37"
      viewBox="0 0 60 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58 18.107L1.93225 18.0957"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58 34.5777L1.93225 34.5664"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.9105 1.64444L2.09027 1.64444"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MenuIcon;
